import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_MCC,
  ADD_MCC,
  UPDATE_MCC,
  DELETE_MCC,
  GET_RANGE_ISO,
  GET_MCC_MASTERCARD_SERVİCE_CATEGORY,
  GET_VISA_SERVICE_CATEGORY,
  GET_MCC_NATIONAL_SWITCH_CATEGORY,
  GET_MCC_GEOGRAPHY_TYPE,
} from "./actionTypes";

import {
  getMccListSuccess,
  addMccSuccess,
  updateMccSuccess,
  deleteMccSuccess,
  apiMccApiError,
  getMccIsoListSuccess,
  getMccMastercardListSuccess,
  getMccVisaServiceCategoryDefListSuccess,
  getMccNationalSwitchListSuccess,
  getMccGeotraphyTypeListSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getMccList,
  addMccDef,
  updateMccDef,
  deleteMccDef,
  getRangeIsoList,
  getMccMastercardServiceCategoryDefList,
  getMccVisaServiceCategoryDefList,
  getMccNationalSwitchCategoryDefList,
  getMccGeographyTypeDefList,
} from "../../helpers/backend_helper/backend_helper";

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetMccGeographyTypeDefList() {
  try {
    const response = yield call(getMccGeographyTypeDefList);
    yield put(getMccGeotraphyTypeListSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}
function* onGetMccNationalSwitchCategoryDefList() {
  try {
    const response = yield call(getMccNationalSwitchCategoryDefList);
    yield put(getMccNationalSwitchListSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}
function* onGetMccVisaServiceCategoryDefList() {
  try {
    const response = yield call(getMccVisaServiceCategoryDefList);
    yield put(getMccVisaServiceCategoryDefListSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}

function* onGetMccMastercardServiceCategoryDefList() {
  try {
    const response = yield call(getMccMastercardServiceCategoryDefList);
    yield put(getMccMastercardListSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}

function* onGetRangeIsoList() {
  try {
    const response = yield call(getRangeIsoList);
    yield put(getMccIsoListSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}

function* onGetMccList() {
  try {
    const response = yield call(getMccList);
    yield put(getMccListSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}

function* onAddMcc({ payload: record }) {
  try {
    const response = yield call(addMccDef, record);
    yield put(addMccSuccess(response));
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}

function* onUpdateMcc({ payload: record }) {
  try {
    const response = yield call(updateMccDef, record);
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
    yield put(updateMccSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}

function* onDeleteMcc({ payload: guid }) {
  try {
    const response = yield call(deleteMccDef, guid);
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
    yield put(deleteMccSuccess(response));
  } catch (error) {
    yield put(apiMccApiError(error));
  }
}

function* mccManagementSaga() {
  yield takeEvery(GET_MCC_GEOGRAPHY_TYPE, onGetMccGeographyTypeDefList);
  yield takeEvery(GET_MCC_NATIONAL_SWITCH_CATEGORY, onGetMccNationalSwitchCategoryDefList);
  yield takeEvery(GET_VISA_SERVICE_CATEGORY, onGetMccVisaServiceCategoryDefList);
  yield takeEvery(GET_MCC_MASTERCARD_SERVİCE_CATEGORY, onGetMccMastercardServiceCategoryDefList);
  yield takeEvery(GET_RANGE_ISO, onGetRangeIsoList);
  yield takeEvery(GET_MCC, onGetMccList);
  yield takeEvery(ADD_MCC, onAddMcc);
  yield takeEvery(UPDATE_MCC, onUpdateMcc);
  yield takeEvery(DELETE_MCC, onDeleteMcc);
}

export default mccManagementSaga;
